import type { ReactNode } from 'react';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useCookie } from '@evrone-erp/react-std';
import type { ThemeKey, ThemeProviderSetThemeHandler } from '@evrone-erp/uikit';
import { Baseline, ThemeProvider as BaseThemeProvider } from '@evrone-erp/uikit';
type TThemeProviderProps = {
  children?: ReactNode;
};
const THEME_TYPE_COOKIE_KEY = 'themeType';
export function ThemeProvider({
  children
}: TThemeProviderProps) {
  const [themeTypeCookie, setThemeTypeCookie] = useCookie<ThemeKey>(THEME_TYPE_COOKIE_KEY);
  const updateThemeTypeCookie: ThemeProviderSetThemeHandler = themeType => {
    if (typeof themeType === 'string') {
      setThemeTypeCookie(themeType, 30);
    }
  };
  return <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="ru">
      <BaseThemeProvider themeType={themeTypeCookie ?? 'dark'} onSetThemeType={updateThemeTypeCookie}>
        <Baseline />
        {children}
      </BaseThemeProvider>
    </LocalizationProvider>;
}